// Copied from transition-web/src/libs/Firebase.ts
import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { initializeFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'
import { CURRENT_CONFIG } from '../config/environment'

const FIREBASE_CONFIG = {
  apiKey: CURRENT_CONFIG.firebaseConfig.apiKey,
  authDomain: CURRENT_CONFIG.firebaseConfig.authDomain,
  projectId: CURRENT_CONFIG.firebaseConfig.projectId,
  storageBucket: CURRENT_CONFIG.firebaseConfig.storageBucket,
  messagingSenderId: CURRENT_CONFIG.firebaseConfig.messagingSenderId,
  appId: CURRENT_CONFIG.firebaseConfig.appId
}

const REGION = CURRENT_CONFIG.functionsRegion || 'europe-west3'

// Configure Firebase for the active environment (dev/prod) via CURRENT_CONFIG.
export const app = initializeApp(FIREBASE_CONFIG)

export const analytics = import.meta.env.MODE === 'production' ? getAnalytics(app) : undefined

// Firestore/Auth/Functions/Storage all use the project configured in FIREBASE_CONFIG.
export const db = initializeFirestore(app, { ignoreUndefinedProperties: true })

export const auth = getAuth(app)

export const functions = getFunctions(app, REGION)

export const storage = getStorage(app)
